import BackgroundImageRotation from "../shared/backgroundImageRotation"

class InfoPopup {

    constructor($modalTargets) {

        this.$modals = $modalTargets
        this.backgroundImageModalRotations = []
        this.animWideScreen = window.matchMedia("(min-width:992px)");
        this.init()

    }

    showModal(index){

        $(this.$modals[index]).modal()

    }

    init(){

        let self = this

        this.$modals.each((index, value) => {

            $(value).on('show.bs.modal', function (e) {
                let zIndex = $(value).css("z-index");
                $('.header').css('z-index', zIndex+1);
            });
      
            $(value).on('hide.bs.modal', function (e) {
                $('.header').css('z-index', "8")
                history.pushState("state", "", " ")
                if(self.backgroundImageModalRotations[index])
                    self.backgroundImageModalRotations[index].stop()
            });

        });

        this.initGalleryIfNotMobile(self);
        $(window).resize(() => {this.initGalleryIfNotMobile(self)});

    }
    
    initGalleryIfNotMobile(scope){

        if(scope.animWideScreen.matches && scope.backgroundImageModalRotations.length === 0){

            scope.initGalleryAnimation();

        }

    }

    initGalleryAnimation(){

        let self = this
        this.$modals.each((index, modalElement) => {
            // Modal clicked
            $(modalElement).on('shown.bs.modal', function (e) {
              let bgImagesWrapper = $(modalElement).find('.slide_modal__images_wrap');
              let bgImages = bgImagesWrapper.find('img');
    
              if(self.backgroundImageModalRotations[index]){
    
                self.backgroundImageModalRotations[index].play()
    
              }else{
              
                bgImages.each((ind, element) => {

                    element.src = $(element).data('src')

                });
    
    
                if ( bgImages.length >  1){

                    self.backgroundImageModalRotations[index] = new BackgroundImageRotation(bgImages);
                    self.backgroundImageModalRotations[index].play()

                }else{

                    bgImages[0].style.opacity = 1

                }
    
              }
            });
    
        });

    }

}

export default InfoPopup;